export const GET_STORES = "stores/GET_STORES";
export const GET_STORES_BYID = "stores/GET_STORES_BYID";